import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { VisaKind } from '../utils/constants';
type VisaFieldsProps = {
  locale?: Locale;
  disabledDis: DataIdentifier[];
};
export const VisaFields = t0 => {
  const $0 = _c(38);
  const {
    locale,
    disabledDis
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(VisaKind);
    $0[1] = t2;
  } else {
    t2 = $0[1];
  }
  let t3;
  if ($0[2] !== t) {
    t3 = t2.map(value => ({
      label: t($ => $.visaKind.options[value]),
      value
    }));
    $0[2] = t;
    $0[3] = t3;
  } else {
    t3 = $0[3];
  }
  const options = t3;
  let t4;
  if ($0[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = diToFormData("id.visa_kind");
    $0[4] = t4;
  } else {
    t4 = $0[4];
  }
  let t5;
  if ($0[5] !== disabledDis) {
    t5 = disabledDis.includes("id.visa_kind");
    $0[5] = disabledDis;
    $0[6] = t5;
  } else {
    t5 = $0[6];
  }
  let t6;
  if ($0[7] !== t) {
    t6 = t(_temp);
    $0[7] = t;
    $0[8] = t6;
  } else {
    t6 = $0[8];
  }
  let t7;
  if ($0[9] !== t) {
    t7 = t(_temp2);
    $0[9] = t;
    $0[10] = t7;
  } else {
    t7 = $0[10];
  }
  let t8;
  if ($0[11] !== t) {
    t8 = t(_temp3);
    $0[11] = t;
    $0[12] = t8;
  } else {
    t8 = $0[12];
  }
  let t9;
  if ($0[13] !== t8) {
    t9 = {
      required: t8
    };
    $0[13] = t8;
    $0[14] = t9;
  } else {
    t9 = $0[14];
  }
  let t10;
  if ($0[15] !== options || $0[16] !== t5 || $0[17] !== t6 || $0[18] !== t7 || $0[19] !== t9) {
    t10 = <Form.Select data-dd-privacy="mask" name={t4} disabled={t5} label={t6} options={options} placeholder={t7} rules={t9} />;
    $0[15] = options;
    $0[16] = t5;
    $0[17] = t6;
    $0[18] = t7;
    $0[19] = t9;
    $0[20] = t10;
  } else {
    t10 = $0[20];
  }
  let t11;
  if ($0[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = diToFormData("id.visa_expiration_date");
    $0[21] = t11;
  } else {
    t11 = $0[21];
  }
  let t12;
  if ($0[22] !== disabledDis) {
    t12 = disabledDis.includes("id.visa_expiration_date");
    $0[22] = disabledDis;
    $0[23] = t12;
  } else {
    t12 = $0[23];
  }
  let t13;
  if ($0[24] !== t) {
    t13 = t(_temp4);
    $0[24] = t;
    $0[25] = t13;
  } else {
    t13 = $0[25];
  }
  let t14;
  if ($0[26] !== t) {
    t14 = t(_temp5);
    $0[26] = t;
    $0[27] = t14;
  } else {
    t14 = $0[27];
  }
  let t15;
  if ($0[28] !== t14) {
    t15 = {
      required: t14
    };
    $0[28] = t14;
    $0[29] = t15;
  } else {
    t15 = $0[29];
  }
  let t16;
  if ($0[30] !== locale || $0[31] !== t12 || $0[32] !== t13 || $0[33] !== t15) {
    t16 = <Form.Date data-dd-privacy="mask" name={t11} disabled={t12} label={t13} locale={locale} rules={t15} testID="visa-expiration-date" />;
    $0[30] = locale;
    $0[31] = t12;
    $0[32] = t13;
    $0[33] = t15;
    $0[34] = t16;
  } else {
    t16 = $0[34];
  }
  let t17;
  if ($0[35] !== t10 || $0[36] !== t16) {
    t17 = <>{t10}{t16}</>;
    $0[35] = t10;
    $0[36] = t16;
    $0[37] = t17;
  } else {
    t17 = $0[37];
  }
  return t17;
};
function _temp($_0) {
  return $_0.visaKind.label;
}
function _temp2($_1) {
  return $_1.visaKind.placeholder;
}
function _temp3($_2) {
  return $_2.visaKind.error;
}
function _temp4($_3) {
  return $_3.visaExpiration.label;
}
function _temp5($_4) {
  return $_4.visaExpiration.error.required;
}